import { render } from "./partener-form.vue?vue&type=template&id=bc7a4d56&scoped=true&ts=true"
import script from "./partener-form.vue?vue&type=script&lang=ts"
export * from "./partener-form.vue?vue&type=script&lang=ts"

import "./partener-form.vue?vue&type=style&index=0&id=bc7a4d56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7a4d56"]])

export default __exports__